import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  accent?: boolean;
}

export default function SectionHeading({ title, subtitle, action, accent = false }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <div className="flex items-center gap-3">
          <span className={`w-1.5 h-6 rounded-full ${accent ? "bg-accent-500" : "bg-primary-600"}`}></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 ml-5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}